'use strict'

export let norwegian={
  report: {
    cancel: "Avbryt",
    publishReport: "Publiser rapport",
    publishInProgress: "... publisering pågår ...",
    inProgress: " .. pågår",
    saveDraft: "Lagre utkast",
    listLimitedTo: "Rapporten er begrenset til bare å vise",
    top5Risks: "top 5 riski",
    top5Issues: "top 5 saker"
  },
  Overview: {
    title: "Oversikt",
    fields: {
      period: {
        title: "Rapporteringsperiode",
        help: "Angi start og sluttdato for denne statusrapporten. Dobbeltklikk på en dato i kalenderen for å angi startdato. Enkeltklikk på en dato for å angi sluttdato."
      },
      summary: {
        title: "Oppsummering",
        help: "Hvilken fase og livssyklusfase er prosjektet i akkurat nå? Har noen viktige milepæler bare passert, eller er det noen i nær fremtid? Er det noen nylige suksesser eller gjennomslag i prosjektet? Hva er for tiden de viktigste utfordringene? Hva er prosjektets generelle helsetilstand?",
        description:"Beskriv prosjektets overordnede status. Anta at leseren ikke har lest den forrige rapporten eller vet detaljene i prosjektet."
      },
      performedAchivements: {
        title: "Denne perioden",
        help: "Hvilke arbeidspakker ble gjennomført eller fullført denne perioden? Hvilke produkter ble gjennomført denne perioden? Var det planlagt at noen produkter skulle være ferdig, men som ikke fullført denne perioden? Har det vært utført noen korrigerende tiltak i perioden?",
        description: "Beskriv målene som ble oppnådd i denne perioden"

      },
      plannedAchivements: {
        title: "Neste periode",
        help: "Hvilke arbeidspakker vil bli gjennomført eller vil bli fullført i kommende periode? Hvilke produkter er planlagt å være ferdig i kommende periode? Eventuelle korrigerende tiltak planlagt for den kommende perioden?",
        description: "Beskriv målene som er fastsatt for neste periode"
      },
      deliveryStatus: {
        title: "Status på ferdigstilling",
        columns: {
          product: { title: "Planlagt denne etappen" },
          responsible: { title: "Ansvarlig" },
          dueDate: { title: "Tidsfrist" },
          status: { title: "Status" }
        }
      },

      benefits: {
        title: "Gevinster",
        help: "Er vi i rute for å levere den ønskede avkastningen på investeringen? Hvis ikke, hva er forskjellen og hvorfor? Er eventuelle nye gevinster lagt til eller fjernet fra begrunnelsen?",
        description: "Beskriv hvordan begrunnelsen for prosjektet har utviklet seg"
      },
      time: {
        title: "Tid",
        help:"Hva er den siste prognosen for å fullføre denne etappen, og hvordan er den sammenlignet med den godkjente planen? Hva er den siste prognosen for å fullføre prosjektet, og hvordan er det sammenlignet med den godkjente planen?",
        description: "Beskriv hvordan fremdriften av prosjektet og etappen ligger ann i forhold til mål og toleranser"
      },
      cost: {
        title: "Kostnad",
        help:"Hvor mye er brukt til nå i gjeldende etappe, hva er det forventet å bli brukt i denne etappen og hva er det nåværende godkjente utgifter for etappen? Hvor mye er brukt til dags dato i prosjektet, hva forventes å bli brukt i prosjektet og hva er nåværende godkjente utgifter i prosjektet?",
        description: "Beskriv hvordan kostnadene i prosjektet og etappen er i forhold til mål og toleranser"
      },

      quality: {
        title: "Kvalitet",
        help:"Har produkter som er levert denne perioden oppfylt de avtalt kvalitetskriteriene? Har akseptmetodene (testing, vurderinger ...) for produktene i denne perioden blitt fulgt som avtalt? Har produktene til dags dato i prosjektet oppfylt de avtalt kvalitetskriteriene? Har gjeldende kvalitetsstandarder og prosesser blitt fulgt i løpet av denne perioden og hittil i prosjektet?",
        description: "Beskriv hvordan funksjonene og kravene til prosjektet og etappen ligger ann i forhold til toleransene"
      },
      scope: {
        title: "Omfang",
        help:"Var produktene for denne perioden identifisert og godt definert - inkludert sammensetning og kvalitetskriterier? Er produktene for dette prosjektet identifisert og godt definert? Er det noen endringer i omfanget?",
        description: "Beskriv hvordan prosjektet ligger ann i forhold til det avtalte omfanget"
      },

      risk: {
        title: "Risiko",
        help:"Hva er det nåværende risikonivået i prosjektet og hvordan samsvarer det med interessentene risikovilligheten? Hva er de viktigste risikoene og hvilke tiltak er utført?",
        description: "Beskriv hvordan dagens risikonivå er sammenlignet med det avtalt risikoappetitten"
      },

      teamPerformance: {
        title: "Gjennomgang av teamets prestasjon",
        help: `Hvordan ble prosjektgruppen opprinnelig organisert? Hadde teamet de ferdigheter og kapasitet som trengs? Har vi hatt noen endringer i teamet under prosjektet? Hvis ja, hvordan har det påvirket ytelsen? En hvilken som helst god prestasjon i teamet som skal gjenkjennes?`,
        description: "Beskriv prosjektgruppenes ytelse, spesielt anerkjennelse av god ytelse."
      },
      lessonsDescription: {
        title: "Erfaringer",
        help: `Hva gikk bra, hva gikk dårlig og hva er anbefalinger for fremtidige prosjekter av tilsvarende art? Hva er de viktigste leksjonene som er lært? Hvordan skal disse leksjonene lagres og gjenbrukes?`,
        description: "Oppsummer erfaringene i dette prosjektet."
      }
    }
  },
  Preview: {
    title: "Forhåndvisning"
  }
};



// WEBPACK FOOTER //
// ./views/progress/labels/norwegian.js